// extracted by mini-css-extract-plugin
export default {"rating":"tI-z","numberOfStars":"uI-z","count":"vI-z","barGraphSpacing":"wI-z","barGraph":"xI-z"};